"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _bestApps = _interopRequireDefault(require("../../assets/logo/best-apps.png"));

var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Container = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex flex-column align-items-center"
  };
}).withConfig({
  displayName: "Catcher__Container",
  componentId: "ac6x8l-0"
})(["background-color:", ";height:100vh;width:100vw;"], function (props) {
  return props.theme["light-grey"];
});

var ErrorIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "Catcher__ErrorIcon",
  componentId: "ac6x8l-1"
})(["margin-top:56px;color:#bf0d3e;font-size:50px;"]);

var Title = _styledComponents["default"].div.attrs(function () {
  return {
    className: "my-4"
  };
}).withConfig({
  displayName: "Catcher__Title",
  componentId: "ac6x8l-2"
})(["font-size:28px;color:", ";"], function (props) {
  return props.theme["mlb-blue"];
});

var Desc = _styledComponents["default"].div.withConfig({
  displayName: "Catcher__Desc",
  componentId: "ac6x8l-3"
})(["font-size:16px;color:", ";"], function (props) {
  return props.theme["dark-grey"];
});

var Logo = _styledComponents["default"].img.withConfig({
  displayName: "Catcher__Logo",
  componentId: "ac6x8l-4"
})(["width:160px;"]);

var Catcher =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Catcher, _React$Component);

  function Catcher(props) {
    var _this;

    _classCallCheck(this, Catcher);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Catcher).call(this, props));
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(Catcher, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      // Here we can log to a service now or email/slack if we need to see the errors that happen and crash prod if it ever happens
      console.log(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return _react["default"].createElement(Container, null, _react["default"].createElement(ErrorIcon, {
          iconName: "fa-exclamation-circle"
        }), _react["default"].createElement(Title, null, "Oops! Something went wrong..."), _react["default"].createElement(Desc, null, "Please clear your cache and try again."), _react["default"].createElement(Desc, null, "If your problem persists, contact ", this.props.appName, " support."), _react["default"].createElement(Logo, {
          src: _bestApps["default"]
        }));
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      console.log(error);
      return {
        hasError: true
      };
    }
  }]);

  return Catcher;
}(_react["default"].Component);

Catcher.propTypes = {
  /** Name of the application */
  appName: _propTypes["default"].string.isRequired,

  /** Children to display */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = Catcher;
exports["default"] = _default;